module.exports = __webpack_public_path__ + "static/media/convincing.2783ddfd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/convincing.jpg
// module id = 801
// module chunks = 5